
const Grid = ({
  children,
  cols = "1",
  mdCols=cols,
  rows = "auto",
  gap = "4",
  colGap,
  rowGap,
  autoFlow = "row",
  autoRows,
  autoCols,
  className = "",
}) => {
  const gridClasses = [
    `grid`,
    `grid-cols-${cols}`,
    rows !== "auto" && `grid-rows-${rows}`,
    gap && !colGap && !rowGap && `gap-${gap}`,
    colGap && `gap-x-${colGap}`,
    rowGap && `gap-y-${rowGap}`,
    autoFlow !== "row" && `grid-flow-${autoFlow}`,
    autoRows && `auto-rows-${autoRows}`,
    autoCols && `auto-cols-${autoCols}`,
    mdCols && `md:grid-cols-${mdCols}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <div className={gridClasses}>{children}</div>;
};

const GridItem = ({
  children,
  colSpan = "1",
  rowSpan = "1",
  colStart,
  colEnd,
  rowStart,
  rowEnd,
  justifySelf,
  alignSelf,
  className = "",
}) => {
  const itemClasses = [
    colSpan && `col-span-${colSpan}`,
    rowSpan && `row-span-${rowSpan}`,
    colStart && `col-start-${colStart}`,
    colEnd && `col-end-${colEnd}`,
    rowStart && `row-start-${rowStart}`,
    rowEnd && `row-end-${rowEnd}`,
    justifySelf && `justify-self-${justifySelf}`,
    alignSelf && `self-${alignSelf}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <div className={itemClasses}>{children}</div>;
};


export { Grid, GridItem };